<template>
    <div  class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                        Bundesländer
                    </h3>
                </div>
                <div class="col text-right">
                    <base-button size="sm" type="secondary" @click="changePage(page)" icon="fas fa-sync-alt"></base-button>
                </div>
            </div>
        </div>
        <!---<div v-if="$store.getters['profiles/showProfiles'].length > 0 && !$store.getters['profiles/isLoading'] && typeof $store.getters['profiles/showProfiles'][0].id !== 'undefined'" class="table-responsive">--->
        <div class="table-responsive">
            <base-table class="table align-items-center table-flush"
                        :class="type === 'dark' ? 'table-dark': ''"
                        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                        tbody-classes="list"
                        :data="tableData">
                <template slot="columns">
                    <th>id</th>
                    <th>Bundesland</th>
                    <th>Intervall</th>
                    <th>Art</th>
                    <th>Mindestalter</th>
                    <th>Nächstes Reporting</th>
                    <th></th>
                </template>

                <template slot-scope="{row}">
                    <th v-on:dblclick="editable.push(row.id)" scope="row">
                        <div v-if="isLoadingData" class="loading"> </div><div v-else>{{row.id}}</div>
                    </th>
                    <td v-on:dblclick="editable.push(row.id)" >
                        <div v-if="isLoadingData" class="loading"> </div><div v-else><span v-if="!editable.includes(row.id) || isLoading">{{row.name}}</span>
                        <base-input v-else v-model="row.name" class="form-no-padding" input-classes="form-no-padding"></base-input></div>
                    </td>
                    <!--- seems to have no function
                    <td v-on:dblclick="editable.push(row.id)" >
                        <div v-if="isLoadingData" class="loading"> </div><div v-else><span v-if="!editable.includes(row.id) || isLoading">{{row.period}}</span>
                        <select v-else v-model="row.period"
                                class="custom-select form-control form-no-padding">
                            <option v-for="o in periodeOptions" :key="o.value" :value="o.value">{{ o.text }}</option>
                        </select>
                    </div>
                    </td> --->
                    <td v-on:dblclick="editable.push(row.id)" >
                        <div v-if="isLoadingData" class="loading"> </div><div v-else><span v-if="!editable.includes(row.id) || isLoading">{{row.intervall}} {{(row.intervall === 1) ? 'Jahr' : 'Jahre'}}</span>
                        <select v-else v-model="row.intervall"
                                class="custom-select form-control form-no-padding">
                            <option v-for="o in intervallOptions" :key="o.value" :value="o.value">{{ o.text }}</option>
                        </select></div>
                    </td>
                    <td v-on:dblclick="editable.push(row.id)">
                        <div v-if="isLoadingData" class="loading"> </div><div v-else><span v-if="!editable.includes(row.id) || isLoading">{{typeOptions.find(obj => obj.value === row.reportdaytype ).text}}</span>
                        <select v-else v-model="row.reportdaytype"
                                class="custom-select form-control form-no-padding">
                            <option v-for="o in typeOptions" :key="o.value" :value="o.value">{{ o.text }}</option>
                        </select></div>
                    </td>
                    <td v-on:dblclick="editable.push(row.id)">
                        <div v-if="isLoadingData" class="loading"> </div><div v-else><span v-if="!editable.includes(row.id) || isLoading">{{row.minage}} Jahre</span>
                        <base-input v-else v-model="row.minage" class="form-no-padding" input-classes="form-no-padding"></base-input></div>
                    </td>
                    <td v-on:dblclick="editable.push(row.id)">
                        <div v-if="isLoadingData" class="loading"> </div><div v-else><span v-if="!editable.includes(row.id) || isLoading">{{row.upcomingReportAt|formatDateToDay}}</span>
                        <base-input v-else
                                placeholder="Nächstes Reporting"
                        >
                            <flat-pickr slot-scope="{focus, blur}"
                                        @on-open="focus"
                                        @on-close="blur"
                                        ref="pickr"
                                        :config="config"
                                        :class="['form-control','datepicker']"
                                        v-model="row.upcomingReportAt">
                            </flat-pickr>
                        </base-input>
                        </div>
                    </td>
                    <td class="text-right">
                        <div v-if="isLoadingData" class="loading-button"> </div><div v-else><template>
                            <base-button v-if="!editable.includes(row.id)" v-on:click="editable.push(row.id)" icon="fas fa-pencil-alt" type="secondary" icon-only
                                         title="Quickedit"></base-button>
                            <div v-else>
                                <base-button v-on:click="editable.splice(editable.indexOf(row.id),1)" v-if="!isLoading" icon="fa fa-ban" type="secondary" icon-only
                                                                           title="abbrechen"></base-button>
                                <base-button v-on:click="editState(row)" :disabled="isLoading" :icon="(isLoading) ? 'fas fa-circle-notch fa-spin' : 'fas fa-save'" type="primary" icon-only
                                                                            title="speichern"></base-button></div>
                        </template></div>
                    </td>
                </template>
            </base-table>
        </div>
        <div class="card-footer d-flex justify-content-end"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <base-pagination :total="totalitems" v-on:input="changePage" :value="page"></base-pagination>
        </div>
    </div>
</template>

<script>
    import FlatPickr from "vue-flatpickr-component"
    import "flatpickr/dist/flatpickr.css";
    import {German} from "flatpickr/dist/l10n/de.js";

    export default {
        name: "editStatesTable",
        components: {FlatPickr},
        props: {
            type: {
                type: String
            },
            title: String
        },
        data() {
            return {
                editable: [],
                userFilter: {active: false, user: null},
                tableData:[
                    {
                        id:0,
                        name: "Keine Daten",
                        period: null,
                        intervall: null,
                        reportdaytype: null,
                        upcomingReportAt: null,
                        minage: 18
                    }
                ],
                periodeOptions: [{value: 'previous', text: 'Vorherige'},{value: 'deadline', text: 'Deadline'}],
                typeOptions: [{value: 'master', text: 'Zentrales Datum'},{value: 'custom', text: 'Individuelles datum'}],
                intervallOptions: [{value: 1, text: '1 Jahr'},{value: 2, text: '2 Jahre'},{value: 3, text: '3 Jahre'},{value: 4, text: '4 Jahre'}],
                config: {
                    dateFormat: 'Y-m-d',
                    altFormat: 'd.m.Y',
                    altInput: true,
                    allowInput: true,
                    locale: German
                },
                totalitems:0,
                page:1,
                isLoading: false
            }
        },
        created() {
            this.changePage(this.page);
        },
        computed: {
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            },
            isLoadingData() {
                return this.isLoading;
            },
        },
        watch: {
            userFilterUser: function () {
                this.changePage(this.page)
            }
        },
        methods: {
            editState(data) {
                return new Promise(() => {
                    this.isLoading = true;
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/merge-patch+json';
                    let senddata = JSON.parse(JSON.stringify(data));
                    const requestOptions = {
                        method: 'PATCH',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/states/`+data.id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.$store.dispatch('alert/success', 'Bundesland '+response.name+' (ID: '+response.id+') wurde editiert.');
                                this.editable.splice(this.editable.indexOf(data.id),1)
                            },
                            error => {
                                this.isLoading = false;
                                this.$store.dispatch('alert/error', error);
                            });
                });
            },
            changePage(page) {
                this.isLoading = true;
                this.getTableData(page).then(
                    response => {
                        this.tableData = response.member;
                        this.totalitems = response.totalItems;
                        this.page = page;
                        this.isLoading = false;
                    }
                )
            },
            getTableData(page){
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    let url = process.env.VUE_APP_API_SERVER + `/api/states?page=` + page;
                    if (this.userFilter.user !== null) url = url + '&user=' + this.userFilter.user;

                    fetch(url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            resolve({
                                totalItems: response['hydra:totalItems'],
                                member: response['hydra:member']
                            });
                        }, error => {reject(error); });
                });
            }
        }
    }
</script>

<style scoped>
    .form-no-padding {
        padding: 0;
        margin: 0;
    }
    .datepicker-margin {
        margin: 10px;
    }
</style>